import React from 'react';
import { Field, reduxForm } from 'redux-form';

import Typography from '@material-ui/core/Typography';
import HelpIcon from '@material-ui/icons/Help';

import {
  DEFAULT_LANGUAGE,
  AVAILABLE_LANGUAGES
} from 'pages/create-activity/constants';

import {
  FormActionButtons,
  Input,
  MultipleSelectField,
} from 'components';
import { TRANSLATIONS } from 'translations/index';

import validate from './validateSecondLanguage';
import {useRentalItemValidation} from './ValidationTitle'

import { useStyles } from 'components/general-create/styles';

const RentalGeneralCreateSecondLanguage = ({
  save,
  onSubmit,
  handleSubmit,
  isUpdate,
  setSubmitButton,
  formValues = {},
  ...otherProps
}) => {
  const {
    languages,
    selectedLanguage,
    addLanguage,
    deleteLanguage,
    selectLanguage
  } = otherProps;

   const {
      validationErrors,
      updateField,
      validateOnSubmit,
    } = useRentalItemValidation();
  
    const onSubmitHandler = (e) => {
      e.preventDefault();
      const isValid = validateOnSubmit(formValues);
      if (!isValid) return; 
  
      handleSubmit(e); 
    };

  const classes = useStyles();
  const availableLanguages = [...AVAILABLE_LANGUAGES].filter(
    x => !languages.includes(x)
  );

  return (
    <div className={classes.wrapper}>
      <Typography variant="h1" className={classes.title}>
        General
      </Typography>
      <MultipleSelectField
        availableItems={availableLanguages}
        notAvailableToDeleteItems={[DEFAULT_LANGUAGE]}
        list={languages}
        selectedItem={selectedLanguage}
        addItem={addLanguage}
        deleteItem={deleteLanguage}
        selectItem={selectLanguage}
      />
      <form onSubmit={onSubmitHandler}>
        <Field
          name={`title`}
          inputProps={{ maxLength: 255 }}
          label={`${TRANSLATIONS[selectedLanguage].title} *`}
          placeholder={`${TRANSLATIONS[selectedLanguage].title}`}
          className={classes.inputIndent}
          component={Input}
          onChangeCustom={value => updateField('title_no', value)}
          error={Boolean(validationErrors.title)}
        />
        
        <FormActionButtons
          cancelPath="/accommodations-and-activities"
          actionLabel="Next"
          setSubmitButton={setSubmitButton}
          isUpdate={isUpdate}
        />
      </form>
    </div>
  );
};

export default reduxForm({
  form: `generalForm`,
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  touchOnBlur: false,
  validate,
  useRentalItemValidation
})(RentalGeneralCreateSecondLanguage);
